import React, { useEffect, useState } from "react";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import { SubscriptionListService } from "../../Services/ApiServices";
import { useDispatch, useSelector } from "react-redux";
import {
  CatchMessage,
  JSONtoformdata,
  MomentDate,
  tokenisValid,
} from "../../Shared/Methods";
import { toast } from "react-toastify";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";
import Loader from "../../SharedComponents/Loader/Loader";
import { Col, Modal, Row } from "antd";
import classes from "../Modal.module.css";
import CommonButton from "../../Components/Buttons/CommonButton";
import CommonNodataFound from "../../Components/CommonNodataFound";
import Commonpagination from "../../Components/Tables/CommonPagination";
import styles from "./DeviceMeterHistory.module.css";

function DeviceMeterHistoryModal({
  closable,
  open,
  onCancel,
  item,
}: {
  closable: boolean;
  open: boolean;
  onCancel: () => void;
  item: any;
}) {
  const { LoginData } = useSelector((state: any) => state.Auth);
  const dispatch = useDispatch();
  const [subscriptionList, setSubscriptionList] = useState<any>({
    currentplan: [],
    upcommingplan: [],
    data: {},
  });
  const { loading } = useSelector((state: any) => state.Dashboard);
  const { currentplan, upcommingplan, data } = subscriptionList;
  const { items, size, page, total_count } = data;
  const [pageSize, setpageSize] = useState(10);
  const [showText, setShowText] = useState<any>({ isView: false, index: "" });

  useEffect(() => {
    if (LoginData !== null) {
      handleGetSubscriptionList();
    }
  }, [LoginData]);

  const handleGetSubscriptionList = (page = 1, size = 10) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      meter_id: item?.meter_id,
      subscription_status: 1,
    };

    SubscriptionListService(page, size, JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          let data = res.data.data?.items?.map((ele: any) => {
            if (ele?.is_active === 1) {
              setSubscriptionList((pre: any) => {
                return { ...pre, currentplan: [ele.is_active] };
              });
            } else {
              setSubscriptionList((pre: any) => {
                return { ...pre, upcommingplan: [ele?.is_active] };
              });
            }
          });
          setSubscriptionList((pre: any) => {
            return {
              ...pre,
              data: res.data.data,
            };
          });
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => {
        CatchMessage(err);
      })
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const Changesize = (current: number, size: number) => {
    // setPageInd(0); //change into 0 from 1
    setpageSize(size);
    handleGetSubscriptionList(1, size);
  };

  return (
    <>
      <Loader isLoader={loading} />

      <Modal open={open} closable={closable} width={900} footer={null}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>Subscription History</h4>
          <div>
            <h5 style={{ color: "darkred" }}>Current plan</h5>
            <div
              className={`${styles.subscription_scroll_container} scroll_inner`}
            >
              <Row gutter={[16, 16]} style={{ margin: "10px" }}>
                {currentplan.includes(1) ? (
                  items?.map((ele: any, ind: number) => {
                    let Description =
                      ele?.subscriptio_description?.split("\r\n");

                    return (
                      <>
                        {ele?.is_active === 1 && (
                          <Col lg={8} sm={12} xs={12}>
                            <div className={styles.subscription_container}>
                              <div className={styles.sub_container_bottom}>
                                <p className={styles.pro_text}>
                                  {ele?.subscription_name}
                                </p>
                              </div>

                              <div style={{ padding: "15px" }}>
                                <p className={styles.validity_text}>
                                  <span>{ele?.validity}</span>{" "}
                                  {ele?.validity > 1
                                    ? "months validity"
                                    : "month validity"}
                                </p>
                                <div
                                  className={
                                    styles.description_parent_container
                                  }
                                >
                                  <p
                                    className={`${styles.description_container} scroll_inner`}
                                    style={
                                      showText.isView && ind === showText.index
                                        ? { height: "auto" }
                                        : {}
                                    }
                                  >
                                    {Description?.map(
                                      (ele: any, ind: number) => {
                                        return <p>{ele}</p>;
                                      }
                                    )}
                                  </p>
                                </div>

                                <div className={styles.keyvaluepair}>
                                  <p>
                                    Subscription Start{" "}
                                    <span>
                                      {MomentDate(ele?.subscription_start)}
                                    </span>
                                  </p>
                                  <p>
                                    Subscription End{" "}
                                    <span>
                                      {MomentDate(ele?.subscription_end)}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        )}
                      </>
                    );
                  })
                ) : (
                  <CommonNodataFound />
                )}
              </Row>
            </div>
          </div>
          <div>
            <h5 style={{ color: "darkred" }}>Upcomming plan</h5>
            <div
              className={`${styles.subscription_scroll_container} scroll_inner`}
            >
              <Row gutter={[16, 16]} style={{ margin: "10px" }}>
                {upcommingplan.includes(0) ? (
                  items?.map((ele: any, ind: number) => {
                    let Description =
                      ele?.subscriptio_description?.split("\r\n");

                    return (
                      <>
                        {ele?.is_active === 0 && (
                          <Col lg={8} sm={12} xs={12}>
                            <div className={styles.subscription_container}>
                              <div className={styles.sub_container_bottom}>
                                <p className={styles.pro_text}>
                                  {ele?.subscription_name}
                                </p>
                              </div>

                              <div style={{ padding: "15px" }}>
                                <p className={styles.validity_text}>
                                  <span>{ele?.validity}</span>{" "}
                                  {ele?.validity > 1
                                    ? "months validity"
                                    : "month validity"}
                                </p>
                                <div
                                  className={
                                    styles.description_parent_container
                                  }
                                >
                                  <p
                                    className={`${styles.description_container} scroll_inner`}
                                    style={
                                      showText.isView && ind === showText.index
                                        ? { height: "auto" }
                                        : {}
                                    }
                                  >
                                    {Description?.map(
                                      (ele: any, ind: number) => {
                                        return <p>{ele}</p>;
                                      }
                                    )}
                                  </p>
                                </div>

                                <div className={styles.keyvaluepair}>
                                  <p>
                                    Subscription Start{" "}
                                    <span>
                                      {MomentDate(ele?.subscription_start)}
                                    </span>
                                  </p>
                                  <p>
                                    Subscription End{" "}
                                    <span>
                                      {MomentDate(ele?.subscription_end)}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        )}
                      </>
                    );
                  })
                ) : (
                  <CommonNodataFound />
                )}
              </Row>
            </div>
          </div>

          <Commonpagination
            onShowSizeChange={Changesize} ///call when page size click
            total={total_count}
            current={page}
            pageSize={size}
            onChange={(e, size) => {
              ///call when page number click
              if (size === pageSize) {
                handleGetSubscriptionList(1, size);
              }
            }}
            showSizeChanger={false}
          />

          <div className={classes.modal_button_container}>
            <CommonButton
              name="Close"
              type="button"
              onClick={() => onCancel()}
              // style={{ backgroundColor: "#eb3131" }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default DeviceMeterHistoryModal;
